/* eslint-disable no-undef */

/*价税额算法 */
import { FormulaFactory } from "./priceTaxFormula";
import { Format } from "./Format";
import "./Challenger";
import { PosInitData } from 'tplus-poslogin';
import { InvAmountsetting } from './Enum'
const _TMath = Symbol('TMath');
const _Format = Symbol('Format');

/**
 * 价税额算法
 * Created by majianb on 2019/4/10
 */

export default class REAlgorithmAdapter {
  constructor(dto) {

    this[_TMath] = new $T.Bap.TMath.NormalCalculator();
    this.isMember = false;
    // 会员ID
    if (dto.Idmember && dto.Idmember > 0) {
      this.isMember = true;
    }
    // 报价是否含税
    this.withTax = dto.withTax || PosInitData("isPriceWithTax");
    // 单价小数位数
    this.priceDecimalDigits = PosInitData("PricePrecision");
    // 数量小数位数
    this.quantityDecimalDigits = PosInitData("QuantityPrecision");
    this[_Format] = new Format();
  }
  /**
   * 价税额参数设置
   */
  InitPriceTaxFormula() {
    var optPriceTaxFormula = {};
    // 报价是否含税
    optPriceTaxFormula.PriceWithTax = this.withTax;
    // 税标
    optPriceTaxFormula.taxFlag = this.taxFlag;
    // 设置是否发票
    optPriceTaxFormula.isInvoice = true;
    // 币种折算方式
    optPriceTaxFormula.currency = null;
    // 是否启用多币种
    optPriceTaxFormula.IsMultiCurrency = false;
    // 单价小数位数
    optPriceTaxFormula.UnitPriceDecimalDigits = this.priceDecimalDigits;
    // 数量小数位数
    optPriceTaxFormula.QuantityDecimalDigits = this.quantityDecimalDigits;
    // 发票单价精度
    optPriceTaxFormula.InvoiceDecimalDigits = this.priceDecimalDigits;
    // 汇率
    optPriceTaxFormula.ExchangeRate = 4;

    let columns = {
      Price: "RetailPrice", //报价原币                       --零售价
      DiscountPrice: "Price", //无税单价原币                 --单价
      Amount: "Amount", //金额原币                     -- 金额
      DiscountTaxPrice: "TaxPrice", //含税单价原币           --含税单价
      AmountTax: "TaxAmount", //含税金额原币                 --含税金额
      TaxRate: "TaxRate", //税率
      DiscountRate: "TotalDiscountRate", //折扣率                -- 综合折扣率
      Quantity: "Quantity", //数量
      Tax: "Tax", //税额原币                                     -- 税额
      DiscountAmount: "DetailDiscountAmount" //折扣额原币           -- 折扣金额
    };
    // if (this.isMember) {
    //   // 报价原币
    //   columns["Price"]="MemberPrice";
    // }
    optPriceTaxFormula.Columns = columns;

    return optPriceTaxFormula;
  }
  /**
   * 数量改变事件
   * @param {*} updateRetailDetail
   */
  QuantityChange(updateRetailDetail) {
    $T.debugger();
    var priceTaxFormula = this.GetFormulaBase(updateRetailDetail);
    priceTaxFormula.QuantityChange();
    // 计算非会员部分的折扣率
    // this.CaculateDiscountRate(updateRetailDetail);

    // 按照金额配置计算实收金额
    this._CalculateTaxAmountByAmountsetting(updateRetailDetail);

    // 零售金额
    updateRetailDetail.RetailAmount = this[_Format].FormatAmount(
      this[_TMath].Multiply(updateRetailDetail.Quantity,
        updateRetailDetail.RetailPrice)
    );
  }
  /**
   * 获取价税额算法
   * @param {*} updateRetailDetail
   */
  GetFormulaBase(updateRetailDetail) {
    var opt = this.InitPriceTaxFormula();
    this.initRetailDate(updateRetailDetail);
    opt.CurrentRowData = updateRetailDetail;
    let priceTaxFormula = FormulaFactory.GetFormula(opt);

    return priceTaxFormula;
  }

  initRetailDate(retailDetail) {
    // TaxPrice	含税单价
    retailDetail.TaxPrice = retailDetail.TaxPrice || 0;
    // RetailPrice	零售价
    retailDetail.RetailPrice = retailDetail.RetailPrice || 0;

    // MemberPrice	会员价
    retailDetail.MemberPrice = retailDetail.MemberPrice || 0;
    // MemberDiscountRate	会员折扣%
    retailDetail.MemberDiscountRate = retailDetail.MemberDiscountRate || 0;
    // DiscountRate	折扣%
    retailDetail.DiscountRate = retailDetail.DiscountRate || 0;
    // Price	单价
    retailDetail.Price = retailDetail.Price || 0;
    // RetailAmount	零售金额
    retailDetail.RetailAmount = retailDetail.RetailAmount || 0;
    // Amount	金额
    retailDetail.Amount = retailDetail.Amount || 0;
    // TaxRate	税率
    retailDetail.TaxRate = retailDetail.TaxRate || 0;
    // Tax	税额
    retailDetail.Tax = retailDetail.Tax || 0;
    // TaxAmount	含税金额
    retailDetail.TaxAmount = retailDetail.TaxAmount || 0;
    // 综合折扣
    if (!retailDetail.TotalDiscountRate) {
      let totalDiscountRate = Math.Multiply(retailDetail.MemberDiscountRate, retailDetail.DiscountRate)
      retailDetail.TotalDiscountRate = this[_Format].Format(totalDiscountRate, 4);
    }
  }

  /**
   * 单价改变事件
   * @param {*单据明细} updateRetailDetail
   */
  DiscountPriceChange(updateRetailDetail) {
    $T.debugger();
    var priceTaxFormula = this.GetFormulaBase(updateRetailDetail);
    priceTaxFormula.DiscountPriceChange();

    // 按照金额配置计算实收金额
    this._CalculateTaxAmountByAmountsetting(updateRetailDetail);

    // 计算非会员部分的折扣率
    this.CaculateDiscountRate(updateRetailDetail);
  }

  /**
   * 含税金额改变
   * @param {*单据明细} updateRetailDetail
   */
  AmountTaxChange(updateRetailDetail) {
    $T.debugger();
    var priceTaxFormula = this.GetFormulaBase(updateRetailDetail);
    priceTaxFormula.AmountTaxChange();

    // 按照金额配置计算实收金额
    this._CalculateTaxAmountByAmountsetting(updateRetailDetail);
    // 计算非会员部分的折扣率
    this.CaculateDiscountRate(updateRetailDetail);
  }

  /**
   * 含税单价改变
   * @param {*} updateRetailDetail
   */
  DiscountTaxPriceChange(updateRetailDetail) {
    $T.debugger();
    var priceTaxFormula = this.GetFormulaBase(updateRetailDetail);
    priceTaxFormula.DiscountTaxPriceChange();

    // 按照金额配置计算实收金额
    this._CalculateTaxAmountByAmountsetting(updateRetailDetail);

    // 计算非会员部分的折扣率
    this.CaculateDiscountRate(updateRetailDetail);
  }

  /**
   * 金额改变
   */
  AmountChange(updateRetailDetail) {
    $T.debugger();
    var priceTaxFormula = this.GetFormulaBase(updateRetailDetail);
    priceTaxFormula.AmountChange();

    // 按照金额配置计算实收金额
    this._CalculateTaxAmountByAmountsetting(updateRetailDetail);

    // 计算非会员部分的折扣率
    this.CaculateDiscountRate(updateRetailDetail);
  }

  /**
   * 税率改变事件
   * @param {*} updateRetailDetail
   */
  TaxRateChange(updateRetailDetail) {
    $T.debugger();
    var priceTaxFormula = this.GetFormulaBase(updateRetailDetail);
    priceTaxFormula.TaxRateChange();

    // 按照金额配置计算实收金额
    this._CalculateTaxAmountByAmountsetting(updateRetailDetail);

    // 计算非会员部分的折扣率
    this.CaculateDiscountRate(updateRetailDetail);
  }
  /**
   * 税额改变事件
   * @param {*} updateRetailDetail
   */
  TaxAmountChange(updateRetailDetail) {
    $T.debugger();
    var priceTaxFormula = this.GetFormulaBase(updateRetailDetail);
    priceTaxFormula.TaxAmountChange();

    // 按照金额配置计算实收金额
    this._CalculateTaxAmountByAmountsetting(updateRetailDetail);

    // 计算非会员部分的折扣率
    this.CaculateDiscountRate(updateRetailDetail);
  }
  /**
   * 报价改变事件
   * @param {*} updateRetailDetail
   */
  PriceChange(updateRetailDetail) {
    $T.debugger();
    if (this.isMember) {
      this.MemberPriceChange(updateRetailDetail);
    } else {
      this.RetailPriceChange(updateRetailDetail);
    }
  }

  /**
   * 零售价改变事件
   * @param {*} updateRetailDetail
   */
  RetailPriceChange(updateRetailDetail) {
    $T.debugger();
    var priceTaxFormula = this.GetFormulaBase(updateRetailDetail);
    priceTaxFormula.PriceChange();
    // 按照金额配置计算实收金额
    this._CalculateTaxAmountByAmountsetting(updateRetailDetail);

    // 零售金额
    let retailAmount = this[_TMath].Multiply(updateRetailDetail.Quantity,
      updateRetailDetail.RetailPrice);
    updateRetailDetail.RetailAmount = this[_Format].FormatAmount(retailAmount);
  }

  /**
   * 会员价改变事件
   * @param {*} updateRetailDetail
   */
  MemberPriceChange(updateRetailDetail) {
    $T.debugger();
    if (this.withTax) {
      // 含税的场合

      /*含税单价＝会员价×会员折扣×折扣
        含税金额＝含税单价×数量
        金额＝含税金额÷（1＋税率）
        税额＝含税金额－金额
        单价＝金额÷数量
        折扣金额＝零售价×数量－含税金额*/

      // 含税单价＝会员价×会员折扣×折扣
      updateRetailDetail.TaxPrice = this[_Format].FormatPrice(
        this[_TMath].Multiply(
          this[_TMath].Multiply(updateRetailDetail.MemberPrice,
            updateRetailDetail.MemberDiscountRate)
          ,
          updateRetailDetail.DiscountRate
        ));

      // 含税金额＝含税单价×数量
      updateRetailDetail.TaxAmount = this[_Format].FormatAmount(
        this[_TMath].Multiply(updateRetailDetail.TaxPrice,
          updateRetailDetail.Quantity)
      );

      // 金额＝含税金额÷（1＋税率）
      updateRetailDetail.Amount = this[_Format].FormatAmount(
        this[_TMath].Divide(updateRetailDetail.TaxAmount,
          this[_TMath].Add(1, updateRetailDetail.TaxRate), true)
      );

      // 税额＝含税金额－金额
      updateRetailDetail.Tax = this[_Format].FormatAmount(
        this[_TMath].Minus(updateRetailDetail.TaxAmount,
          updateRetailDetail.Amount)
      );

      // 单价＝金额÷数量
      updateRetailDetail.Price = this[_Format].FormatPrice(
        this[_TMath].Divide(updateRetailDetail.Amount,
          updateRetailDetail.Quantity, true)
      );

      // 折扣金额＝零售价×数量－含税金额
      updateRetailDetail.DetailDiscountAmount = this[_Format].FormatAmount(
        this[_TMath].Minus(
          this[_TMath].Multiply(updateRetailDetail.RetailPrice, updateRetailDetail.Quantity),
          updateRetailDetail.TaxAmount)
      );

      // detailDto.TotalDiscountRate = SCMFormat.FormatDiscountRate((detailDto.Price * detailDto.Quantity * (1 + (detailDto.TaxRate ?? 0))) / (detailDto.RetailPrice * detailDto.Quantity));
      let temp1 = this[_TMath].Multiply(updateRetailDetail.TaxPrice, updateRetailDetail.Quantity);
      let temp3 = this[_TMath].Multiply(updateRetailDetail.RetailPrice, updateRetailDetail.Quantity);
      if (temp3) {
        // 综合折扣率
        updateRetailDetail.TotalDiscountRate = this[_Format].Format(this[_TMath].Divide(temp1, temp3, true), 4);
      }

    } else {
      // 不含税的场合

      /*
        单价＝会员价×会员折扣×折扣
        金额＝单价×数量
        税额＝金额×税率
        含税金额＝金额＋税额
        含税单价＝含税金额÷数量
        折扣金额＝零售价×数量×（1＋税率）－含税金额
      */

      // 单价＝会员价×会员折扣×折扣
      updateRetailDetail.Price = this[_Format].FormatPrice(
        this[_TMath].Multiply(
          this[_TMath].Multiply(
            updateRetailDetail.MemberPrice,
            updateRetailDetail.MemberDiscountRate
          ),
          updateRetailDetail.DiscountRate
        )
      );

      // 金额＝单价×数量
      updateRetailDetail.Amount = this[_Format].FormatAmount(
        this[_TMath].Multiply(
          updateRetailDetail.Price,
          updateRetailDetail.Quantity
        )
      );

      // 税额＝金额×税率
      updateRetailDetail.Tax = this[_Format].FormatAmount(
        this[_TMath].Multiply(
          updateRetailDetail.Amount,
          updateRetailDetail.TaxRate
        )
      );

      // 含税金额＝金额＋税额
      updateRetailDetail.TaxAmount = this[_Format].FormatAmount(
        this[_TMath].Add(updateRetailDetail.Amount,
          updateRetailDetail.Tax)
      );

      // 含税单价＝含税金额÷数量
      updateRetailDetail.TaxPrice = this[_Format].FormatPrice(
        this[_TMath].Divide(
          updateRetailDetail.TaxAmount,
          updateRetailDetail.Quantity,
          true
        )
      );

      // 折扣金额＝零售价×数量×（1＋税率）－含税金额
      updateRetailDetail.DetailDiscountAmount = this[_Format].FormatAmount(
        this[_TMath].Minus(
          this[_TMath].Multiply(
            this[_TMath].Multiply(
              updateRetailDetail.RetailPrice,
              updateRetailDetail.Quantity
            ),
            this[_TMath].Add(1, updateRetailDetail.TaxRate)
          ),
          updateRetailDetail.TaxAmount
        )
      );

      // detailDto.TotalDiscountRate = SCMFormat.FormatDiscountRate((detailDto.Price * detailDto.Quantity) / (detailDto.RetailPrice * detailDto.Quantity));                

      let temp1 = this[_TMath].Multiply(updateRetailDetail.Price, updateRetailDetail.Quantity);
      // let temp2= this[_TMath].Add(detailDto.TaxRate||0,1);
      let temp3 = this[_TMath].Multiply(updateRetailDetail.RetailPrice, updateRetailDetail.Quantity);
      if (temp3) {
        // 综合折扣率
        updateRetailDetail.TotalDiscountRate = this[_Format].Format(this[_TMath].Divide(temp1, temp3, true), 4);
      }
    }
    // 零售金额
    let retailAmount = this[_TMath].Multiply(updateRetailDetail.Quantity,
      updateRetailDetail.RetailPrice);
    updateRetailDetail.RetailAmount = this[_Format].FormatAmount(retailAmount);

    // 按照金额配置计算实收金额
    this._CalculateTaxAmountByAmountsetting(updateRetailDetail);
  }
  /**
   * 计算非会员部分的折扣率
   * @param {*单据明细} updateRetailDetail
   */
  CaculateDiscountRate(updateRetailDetail) {
    $T.debugger();
    // 会员价
    let memberPrice = updateRetailDetail["MemberPrice"] || 0;
    // 会员折扣
    let memberDiscountRate = updateRetailDetail["MemberDiscountRate"] || 0;
    // 总折扣
    let totalDiscountRate = updateRetailDetail["TotalDiscountRate"] || 0;
    // 数量
    let quantity = updateRetailDetail["Quantity"] || 0;

    if (memberDiscountRate == 0 || totalDiscountRate == 0) {
      updateRetailDetail["DiscountRate"] = 1;
      return;
    }
    // else
    // {
    //   let discountRate = this[_TMath].Divide(totalDiscountRate, memberDiscountRate, true);
    //   updateRetailDetail["DiscountRate"] =this[_Format].Format(discountRate,4);
    // }

    let amount = updateRetailDetail["Amount"] || 0;

    // 含税
    if (this.withTax) {
      amount = updateRetailDetail["TaxAmount"] || 0;
    }
    let temp1 = this[_TMath].Multiply(memberPrice, memberDiscountRate);
    let temp2 = this[_TMath].Multiply(temp1, quantity);
    let discountRate = this[_TMath].Divide(amount, temp2, true);
    updateRetailDetail["DiscountRate"] = this[_Format].Format(discountRate, 4);
  }

  /**
   * 折扣率改变
   * @param {*} updateRetailDetail 
   */
  DiscountRateChange(updateRetailDetail) {
    $T.debugger();
    if (!this.isMember) {
      // 非会员的场合
      // 会员折扣
      let memberDiscountRate = updateRetailDetail["MemberDiscountRate"] || 0;
      // 折扣%
      var discountRate = updateRetailDetail["DiscountRate"]
      // 总折扣率
      var totalDiscountRate = this[_TMath].Multiply(memberDiscountRate, discountRate)
      updateRetailDetail["TotalDiscountRate"] = this[_Format].Format(totalDiscountRate, 4);
      var priceTaxFormula = this.GetFormulaBase(updateRetailDetail);
      // 折扣率改变
      priceTaxFormula.DiscountRateChange();
    }
    else {
      // 调用会员价改变事件
      this.MemberPriceChange(updateRetailDetail);
    }


    // 按照金额配置计算实收金额
    this._CalculateTaxAmountByAmountsetting(updateRetailDetail);
  }

  /**
   * 折扣额改变
   * @param {*} updateRetailDetail 
   */
  DiscountAmountChange(updateRetailDetail) {
    $T.debugger();
    var priceTaxFormula = this.GetFormulaBase(updateRetailDetail);
    // 折扣额改变
    priceTaxFormula.DiscountAmountChange(updateRetailDetail);
    // 按照金额配置计算实收金额
    this._CalculateTaxAmountByAmountsetting(updateRetailDetail);
    // 计算非会员部分的折扣率
    this.CaculateDiscountRate(updateRetailDetail);
  }

  /**
   * 按照金额配置计算实收金额
   * @param {*} updateRetailDetail 
   */
  _CalculateTaxAmountByAmountsetting(updateRetailDetail) {
    $T.debugger();
    // var taxAmount = CalculateTaxAmountByAmountsetting(updateRetailDetail.TaxAmount, PosInitData("invAmountsetting"), InvAmountsetting);
    // if (updateRetailDetail.TaxAmount != taxAmount) {
    //   // 抹零
    //   updateRetailDetail.WipeChange = Math.Minus(updateRetailDetail.TaxAmount, taxAmount);

    //   updateRetailDetail.TaxAmount = taxAmount;
    //   this.AmountTaxChange(updateRetailDetail);
    // }
  }
}
